// AI Generated Component
import { NgModule } from '@angular/core';
import { AuditlogModule } from './auditlog/auditlog.module';
import { ApiUsersModule } from './api-users/api-users.module';
import { UsersModule } from './users/users.module';
import { LabelsModule } from './labels/labels.module';
import { SourceCodeExcludesModule } from './source-code-excludes/source-code-excludes.module';
import { PagePerformancePagesModule } from '@client/app/modules/page-performance/pages/pages.module';

@NgModule({
    imports: [
        AuditlogModule,
        ApiUsersModule,
        UsersModule,
        LabelsModule,
        SourceCodeExcludesModule,
        PagePerformancePagesModule,
    ],
})
export class AdminModule {}
